import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { ProfileDetail } from '@frontend/containers/ProfileDetail';
import { Profiles } from '@frontend/containers/Profiles';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';

var ProfilesPage = function ProfilesPage() {
  var _router$query2;

  var router = useRouter();

  var _useState = useState(''),
      name = _useState[0],
      setName = _useState[1];

  useEffect(function () {
    var _router$query;

    if (router !== null && router !== void 0 && (_router$query = router.query) !== null && _router$query !== void 0 && _router$query.name) {
      setName(router.query.name);
    } else {
      setName('');
    }
  }, [router === null || router === void 0 ? void 0 : (_router$query2 = router.query) === null || _router$query2 === void 0 ? void 0 : _router$query2.name]);
  return name ? _jsx(ProfileDetail, {
    profileName: name
  }) : _jsx(Profiles, {});
};

export var __N_SSG = true;
export default ProfilesPage;